export default __webpack_public_path__ + "static/media/ep_01.c6e62aab.png";